if (document.querySelector('[data-section-type="product-page"]')) {
	setTimeout(() => {
		const targetNode = document.querySelector('.jdgm-aggregate-rating-jld');
		if (targetNode) {
			targetNode.remove();
		}
	}, 1500);
}